import React, { useCallback, useEffect, useState } from "react";
import { IVectorizationDataModel, IVectorizedImageBatchModel, ModelType } from "../../types/vectorization";
import "./VectorizationBatch.scss"
import { createVectorizationBatch } from "../../services/vectorization/loadImagesByBatch";
import { Card, Container, Spinner } from "react-bootstrap";
import BatchVectorizedImages from "./BatchVectorizedImages";
import Pix2PixImage from "./Pix2PixImage";

interface IVectorizationBatchProps {
    vectorizationBatchImages: IVectorizationDataModel[];
}

const VectorizationBatch: React.FC<IVectorizationBatchProps> = ({ vectorizationBatchImages }) => {
    const [isBatchLoading, setIsBatchLoading] = useState(false);
    const [vectorizationBatch, setVectorizationBatch] = useState<IVectorizedImageBatchModel>()

    const loadVectorizationBatch = useCallback(async () => {
        setIsBatchLoading(true);
        setVectorizationBatch(await createVectorizationBatch(vectorizationBatchImages));
        setIsBatchLoading(false);
    }, [vectorizationBatchImages]);

    useEffect(() => {
        loadVectorizationBatch();
    }, [loadVectorizationBatch, vectorizationBatchImages]);

    return (
        <div className="card-with-image">
            <Card className="flex-row p-3 pt-0 gap-3 card-batch">
                {(isBatchLoading || !vectorizationBatch) && (
                    <Container className="w-80 d-flex justify-content-center align-items-center">
                        <Spinner animation="border" role="status" className="me-3">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    </Container>
                )}
                {vectorizationBatch && (
                    <>
                        <div className="pt-3">
                            <Card className="card-wrap-image">
                                <Card.Body className="d-flex justify-content-center align-items-center">
                                    <Card.Img variant="top" src={vectorizationBatch.url}
                                        alt={vectorizationBatch.inputKey} />
                                </Card.Body>
                                <Card.Footer className="d-flex flex-column gap-1">
                                    <span>{vectorizationBatch.startedBy}</span>
                                    <span>{vectorizationBatch.startedAt}</span>
                                </Card.Footer>
                            </Card>
                        </div>
                        <div className="d-flex flex-wrap gap-3">
                            <Pix2PixImage vectorizedImage={vectorizationBatch.batchImages[0]} modelType={ModelType.PIX2PIX} />
                            <Pix2PixImage vectorizedImage={vectorizationBatch.batchImages[0]} modelType={ModelType.HAT} />
                            <BatchVectorizedImages vectorizedImages={[vectorizationBatch.batchImages[0]]}
                                inputFileName={vectorizationBatch.inputFilename}
                                inputKey={vectorizationBatch.inputKey} />

                        </div>
                    </>)}
            </Card>
        </div>
    )
};

export default VectorizationBatch;
